import React from 'react'
import { Link } from 'react-router-dom';
import Teamsimg01 from '../../../assets/images/blog1.png';
import Teamsimg02 from '../../../assets/images/blog2.png';
import Teamsimg03 from '../../../assets/images/blog3.png';
import Teamsimg04 from '../../../assets/images/blog/single-blog-image-3.jpg';
import Logo from '../../../assets/images/logo2.png'

import Teamsimg08 from '../../../assets/images/blog/blog-standard-image-6.jpg';
import Teamsimg09 from '../../../assets/images/blog/blog-standard-image-7.jpg';
import Teamsimg10 from '../../../assets/images/favicon-2.png';

const Teamdetails = () => {
    return (
        <div className="blog-list-section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8">
                        <div className="blog-block">
                            <div className="single-blog-image">
                                <img
                                    src={Teamsimg02}
                                    alt="blog-image"
                                />
                            </div>
                            <div className="blog-item-meta">
                                <p>
                                    <Link to="#">By The NRI Advisor</Link>
                                </p>
                                <p>
                                    <Link to="#">On 24 June 2025</Link>
                                </p>
                            </div>
                        </div>
                        <div className="blog-block">
                            <div className="single-blog-details">
                                <h3>10 Things Every NRI Should Know About OCI Card</h3>
                                <p>
                                For Non-Resident Indians (NRIs) and Persons of Indian Origin (PIO), the Overseas Citizen of India (OCI) card offers several advantages and privileges. Understanding the benefits, application process, and limitations of the OCI card can help streamline your connection with India. Here are 10 essential things every NRI should know about the OCI card:
                                </p>
                                <h3>What is an OCI Card? </h3>
                                <p>
                                The OCI card is a form of permanent residency available to people of Indian origin and their spouses. It grants cardholders various rights and benefits similar to those enjoyed by Indian citizens, although it does not confer full citizenship.
                                </p>
                                <h3>Eligibility Criteria</h3>
                                <p>To be eligible for an OCI card, an applicant must have been an Indian citizen or eligible to become one on or after January 26, 1950, or who belonged to a territory that became part of India after August 15, 1947, or be a descendant of such a person. Additionally, spouses of Indian citizens or OCI cardholders are eligible, provided the marriage is registered and subsisting for at least two years.</p>
                                <h3>Application Process</h3>
                                <p>The OCI application process is straightforward but requires thorough documentation. Applicants need to submit proof of their Indian origin, current passport, photographs, and other relevant documents. Applications can be submitted online through the Indian government’s official portal https://ociservices.gov.in/, followed by a visit to the Indian Mission/Post in the country of citizenship or residence of the applicant for verification.</p>
                                <h3>Lifelong Visa</h3>
                                <p>OCI cardholders enjoy the benefit of a lifelong visa to India. This eliminates the need for regular visa renewals and allows for multiple entries and indefinite stays in India.</p>
                                <h3>Exemption from Reporting to Police</h3>
                                <p>Unlike other visa holders, OCI cardholders are exempt from reporting to the local police authorities for any length of stay in India, simplifying long-term visits and residential arrangements.</p>
                                <h3>Employment and Economic Benefits</h3>
                                <p>OCI cardholders have the right to work in India in most sectors, except for those requiring special permission such as government jobs and certain research activities. They can also purchase non-agricultural property and participate in business and financial activities like Indian residents.</p>
                                <h3>Parity with NRIs</h3>
                                <p>OCI cardholders have parity with NRIs in economic, financial, and educational fields. This includes access to educational institutions under the NRI quota, as well as investment opportunities on par with NRIs.</p>
                                <h3>Not Eligible for Certain Rights</h3>
                                <p>Despite many privileges, OCI cardholders do not have the right to vote, hold a government job, or acquire agricultural land. They are also not eligible for an Indian passport or to stand for public office.</p>
                                <h3>Renewal and Reissuance</h3>
                                <p>The OCI card is valid for the holder’s lifetime. However, reissuance is necessary when the cardholder gets a new passport up to the age of 20 and once after turning 50, due to significant biological changes in appearance.</p>
                                <h3>OCI vs. PIO Card</h3>
                                <p>The PIO card scheme has been merged with the OCI card scheme since January 2015. PIO cardholders are now required to convert their PIO cards to OCI cards. The conversion process is simple and can be done online, ensuring that all previous PIO cardholders can enjoy the benefits of the OCI card.</p>
                                <h3>Key Takeaways</h3>
                                <p>The OCI card is a valuable document for NRIs and people of Indian origin, offering numerous benefits that facilitate a closer connection with India. By understanding the eligibility, application process, and benefits, you can leverage the OCI card to enjoy seamless access to India. Whether for personal visits, business, or long-term stays, the OCI card provides a robust framework for maintaining ties with your heritage while enjoying the conveniences of modern-day travel and residency.</p>
                                <p>Staying informed about the OCI card’s privileges and limitations ensures that you can fully utilize its benefits while being aware of any restrictions. This knowledge is crucial for making informed decisions about your engagement with India.</p>
                            </div>
                        </div>
                        {/* <div className="blog-block">
                            <div className="single-blog-image-two">
                                <div>
                                    <img
                                        src={Teamsimg03}
                                        alt="blog-image"
                                    />
                                </div>
                                <div>
                                    <img
                                        src={Teamsimg04}
                                        alt="blog-image"
                                    />
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="blog-block">
                            <div className="single-blog-details">
                                <h3>The Impact of Credit Scores on Your Loan Application</h3>
                                <p>
                                    We work closely with you to develop a comprehensive financial plan
                                    that aligns with your objectives. This includes budgeting,
                                    forecasting, and identifying key financial metrics to track
                                    progress. By setting clear goals and creating a strategic plan,
                                    you can make informed decisions that drive financial growth. Our
                                    team at loanlift is here to support you every step of the way,
                                    helping you navigate your path to financial freedom with
                                    confidence and clarity.
                                </p>
                            </div>
                        </div> */}
                        {/* <div className="blog-block">
                            <div className="single-blog-quoght">
                                <p>
                                    A dedicated team of 30 professionals highlights the significant
                                    effort is putting innovative lending solutions.these shows that
                                    LoanLift is fully committed to making it a reality.
                                </p>
                                <div className="single-blog-quoght-author">
                                    <span>Johnny M. Martin</span>
                                    <i className="flaticon-quote" />
                                </div>
                            </div>
                        </div> */}
                        <div className="blog-block">
                            <div className="single-blog-link">
                                {/* <ul className="single-blog-tag">
                                    <li>Tags :</li>
                                    <li>
                                        <Link to="#">Loan</Link>
                                    </li>
                                    <li>
                                        <Link to="#">Money</Link>
                                    </li>
                                    <li>
                                        <Link to="#">2024</Link>
                                    </li>
                                </ul> */}
                                <ul className="single-blog-social-media">
                                    <li>Share :</li>
                                    <li>
                                        <Link to="https://www.facebook.com/">
                                            <i className="fa-brands fa-facebook-f" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://x.com/">
                                            <i className="fa-brands fa-twitter" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.instagram.com/">
                                            <i className="fa-brands fa-instagram" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://in.linkedin.com/">
                                            <i className="fa-brands fa-linkedin-in" />
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="blog-block">
                            <div className="single-blog-pagination">
                                <div className="single-blog-pagination-pre">
                                    <Link to="/Blogdetails" className="btn-link-two">
                                        <i className="fa-solid fa-arrow-left" />
                                    </Link>
                                    <h5>
                                        <Link className="single-blog-pagination-link" to="/Blogdetails">
                                        7 Essential Personal Finance Tips for NRIs You Need to Know
                                        </Link>
                                    </h5>
                                </div>
                                <div className="single-blog-pagination-next">
                                    <h5>
                                        <Link className="single-blog-pagination-link" to="/Blogdetails3">
                                        10 Ways NRIs Can Resolve Family Disputes From Afar

                                        </Link>
                                    </h5>
                                    <Link to="/Blogdetails3" className="btn-link-two">
                                        <i className="fa-solid fa-arrow-right" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* <div className="blog-block">
                            <div className="comment-widget">
                                <h3>Comments</h3>
                                <div className="comment-widget-item">
                                    <img
                                        src={Teamsimg05}
                                        alt="comment-image"
                                    />
                                    <div className="comment-widget-item-details">
                                        <div className="comment-meta">
                                            <p>William. L</p>
                                            <span>August 24, 2024</span>
                                        </div>
                                        <div className="comment-text">
                                            <p>
                                                Quis autem vel eum iure reprehenderit qui in ea voluptate
                                                velit esse molestiae consequatur qui dolorem eum fugiat
                                                voluptas
                                            </p>
                                        </div>
                                        <Link to="#" className="comment-reply">
                                            Reply <i className="flaticon-next" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="comment-widget-item reply">
                                    <img
                                        src={Teamsimg06}
                                        alt="comment-image"
                                    />
                                    <div className="comment-widget-item-details">
                                        <div className="comment-meta">
                                            <p>Alina. R</p>
                                            <span>August 28, 2024</span>
                                        </div>
                                        <div className="comment-text">
                                            <p>
                                                Quis autem vel eum iure reprehenderit qui in ea voluptate
                                                velit esse molestiae consequatur qui dolorem eum fugiat
                                                voluptas
                                            </p>
                                        </div>
                                        <Link to="#" className="comment-reply">
                                            Reply <i className="flaticon-next" />
                                        </Link>
                                    </div>
                                </div> */}
                                {/* <div className="comment-widget-item">
                                    <img
                                        src={Teamsimg07}
                                        alt="comment-image"
                                    />
                                    <div className="comment-widget-item-details">
                                        <div className="comment-meta">
                                            <p>Jackson. K</p>
                                            <span>September 05, 2024</span>
                                        </div>
                                        <div className="comment-text">
                                            <p>
                                                Quis autem vel eum iure reprehenderit qui in ea voluptate
                                                velit esse molestiae consequatur qui dolorem eum fugiat
                                                voluptas
                                            </p>
                                        </div>
                                        <Link to="#" className="comment-reply">
                                            Reply <i className="flaticon-next" />
                                        </Link>
                                    </div>
                                </div> */}
                            {/* </div>
                        </div> */}
                        <div className="comment-form-widget">
                            <h3>Leave A Reply</h3>
                            <form action="#">
                                <div className="comment-form-group-one">
                                    <div className="comment-form-group-one-inner">
                                        <label>
                                            <i className="fa-regular fa-user" />
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Full Name"
                                            required=""
                                        />
                                    </div>
                                    <div className="comment-form-group-one-inner">
                                        <label>
                                            <i className="fa-solid fa-phone" />
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Phone"
                                            required=""
                                        />
                                    </div>
                                </div>
                                <div className="comment-form-group-one">
                                    <label>
                                        <i className="fa-regular fa-envelope" />
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        placeholder="Email Address"
                                        required=""
                                    />
                                </div>
                                <div className="comment-form-group-one">
                                    <label>
                                        <i className="fa-solid fa-message" />
                                    </label>
                                    <textarea
                                        name="comment"
                                        rows={4}
                                        className="form-control"
                                        placeholder="Comments"
                                        required=""
                                        defaultValue={""}
                                    />
                                </div>
                                <button type="submit" className="btn btn-secondary">
                                    Leave A comment
                                    <i className="flaticon-next" />
                                </button>
                            </form>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="blog-sidebar stcky">
                            <div className="blog-block">
                                <div className="blog-serch-widget">
                                    <form action="#">
                                        <input type="search" placeholder="Search " />
                                        <button type="submit">
                                            <i className="flaticon-search-interface-symbol" />
                                        </button>
                                    </form>
                                </div>
                            </div>
                            <div className="blog-block">
                                {/* <div className="category-widget">
                                    <h4>Category</h4>
                                    <ul>
                                        <li className="active">
                                            <Link to="#">Home Loan</Link> <span>(05)</span>
                                        </li>
                                        <li>
                                            <Link to="#">Wedding Loan</Link> <span>(09)</span>
                                        </li>
                                        <li>
                                            <Link to="#">Mortgage Loan</Link> <span>(04)</span>
                                        </li>
                                        <li>
                                            <Link to="#">Business Loan</Link> <span>(06)</span>
                                        </li>
                                        <li>
                                            <Link to="#">Education loan</Link> <span>(08)</span>
                                        </li>
                                    </ul>
                                </div> */}
                            </div>
                            <div className="blog-block">
                                <div className="recent-blog-widget" style={{display: "flex", flexDirection: "column", flex: "1", gap: "10px"}} >
                                    <h4>Recent Menu</h4>
                                    <div className="recent-blog-widget-item" style={{display: "flex", flexDirection: "column", flex: "1", gap: "0px"}} >
                                        <img className='img-fluid'
                                            src={Teamsimg01}
                                            alt="blog-image"
                                        />
                                        <div className="recent-blog-widget-item-title" style={{display: "flex", flexDirection: "column", flex: "1", gap: "0px"}}>
                                            <span>On 24 Jun 2025</span>
                                            <Link to="/Blogdetails">
                                            10 Ways NRIs Can Resolve Family Disputes From Afar
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="recent-blog-widget-item" style={{display: "flex", flexDirection: "column", flex: "1", gap: "0px"}}>
                                        <img
                                            src={Teamsimg02}
                                            alt="blog-image"
                                        />
                                        <div className="recent-blog-widget-item-title">
                                            <span>On 24 Jun 2025</span>
                                            <Link to="/Blogdetails">
                                            10 Things Every NRI Should Know About OCI Card
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="recent-blog-widget-item" style={{display: "flex", flexDirection: "column", flex: "1", gap: "0px"}}>
                                        <img
                                            src={Teamsimg03}
                                            alt="blog-image"
                                        />
                                        <div className="recent-blog-widget-item-title">
                                            <span>On 24 Jun 2025</span>
                                            <Link to="/Blogdetails">
                                            7 Essential Personal Finance Tips for NRIs You Need to Know
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="blog-block">
                                <div className="tag-widget">
                                    <h4>Popular Tags</h4>
                                    <ul>
                                        <li className="active">
                                            <Link to="#">Finance</Link>
                                        </li>
                                        <li>
                                            <Link to="#">loanlift</Link>
                                        </li>
                                        <li>
                                            <Link to="#">Investors</Link>
                                        </li>
                                        <li>
                                            <Link to="#">Investors</Link>
                                        </li>
                                        <li>
                                            <Link to="#">Credit Score</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div> */}
                            <div className="blog-block mb-0">
                                <div className="bolg-cta-widget">
                                    <div className="bolg-cta-widget-inner">
                                        <img src={Logo} alt="logo" />
                                        <h3>Premier Advisory Specialists for NRIs</h3>
                                        <p className="lead">
                                            <Link to="tel:+1 732-734-2800">
                                                <i className="flaticon-phone" /> +1 732-734-2800            
                                            </Link>
                                        </p>
                                        <Link to="/Contactus" className="btn btn-primary">
                                            Get Started <i className="flaticon-next" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default Teamdetails;